// Генератор парольной фразы на основе криптостойкого ГСЧ браузера.
// Пароль показывается пользователю один раз и нигде не хранится в открытом виде.

const WORDS = [
    "apple", "amber", "anchor", "arrow", "autumn", "basil", "beacon", "birch",
    "bison", "bloom", "bottle", "branch", "bridge", "bronze", "canyon", "cedar",
    "cherry", "cloud", "clover", "cobalt", "comet", "copper", "coral", "cotton",
    "crystal", "delta", "diamond", "dolphin", "dragon", "ember", "emerald", "falcon",
    "feather", "fennel", "forest", "fox", "garden", "ginger", "glacier", "granite",
    "harbor", "hazel", "hollow", "indigo", "island", "ivory", "jasper", "jungle",
    "kettle", "lagoon", "lantern", "ledger", "lemon", "lily", "linen", "lotus",
    "lunar", "maple", "marble", "meadow", "meteor", "mint", "moss", "nebula",
    "nectar", "nickel", "ocean", "olive", "onyx", "orchid", "otter", "pebble",
    "pepper", "pewter", "pine", "planet", "plum", "prairie", "quartz", "quill",
    "rapid", "raven", "ribbon", "river", "rocket", "saffron", "sage", "salmon",
    "sapphire", "sequoia", "shadow", "silver", "spruce", "stone", "storm", "summit",
    "sunset", "tangle", "thistle", "thunder", "tiger", "timber", "topaz", "tulip",
    "tundra", "valley", "velvet", "violet", "walnut", "willow", "winter", "zephyr"
];

// Криптостойкое случайное целое в диапазоне [0, max) без модульного смещения.
function randomInt(max) {
    const limit = Math.floor(0xffffffff / max) * max;
    const buf = new Uint32Array(1);
    let value;
    do {
        crypto.getRandomValues(buf);
        value = buf[0];
    } while (value >= limit);
    return value % max;
}

function capitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}

// Возвращает фразу вида "River-Stone-Maple" (три слова, чтобы легко запоминалась)
export function generatePassphrase(wordCount = 3) {
    const parts = [];
    for (let i = 0; i < wordCount; i++) {
        parts.push(capitalize(WORDS[randomInt(WORDS.length)]));
    }
    return parts.join("-");
}
